export default __webpack_public_path__ + "static/media/img-06.ef203d42.jpg";